import React from 'react';
import T from 'components/T';
import { i18n } from '@international/mastodon-i18n';
import { getSectionDisplayName } from '../lib/screenings';

interface DescribeInaccurateTextFormProps {
  section: string;
}

const DescribeInaccurateTextForm = ({
  section,
}: DescribeInaccurateTextFormProps) => {
  return (
    <div data-testid='describe-inaccurate-form'>
      <div className='cp-form-group'>
        <span className='text-very-muted'>
          {`${getSectionDisplayName(section)} > `}
          <T value='components.Report.Dispute.DescribeSituation.MoreAboutRecordRootPath' />
          {' > '}
        </span>
        <span className='form-question'>
          <T value='components.Report.Dispute.DescribeSituation.MoreAboutRecordCurrentPath' />
        </span>
        <hr />
      </div>
      <div className='cp-form-group'>
        <T
          value='components.Report.Dispute.DescribeSituation.MoreAboutRecordText'
          dangerousHTML
        />
      </div>
    </div>
  );
};

export default i18n.renderTranslation()(DescribeInaccurateTextForm);
